<mat-form-field class="mxs-input mxs-color-picker mx-color-picker"
                *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <div class="color-picker-wrapper" [style.border-color]=color>
        <input #pickerBtn class="btn-color-picker" (click)="pickerBtn.click()"
               matInput
               readonly
               [formControlName]="name"
               [readOnly]=true
               [required]=true
               [cpPosition]="'bottom'"
               [cpOKButton]="true"
               [cpCancelButton]="true"
               [cpPositionRelativeToArrow]="true"
               cpAddColorButtonText="Ok"
               cpAddColorButtonClass="btn-clr-pkr"
               [cpPresetColors]="presetColors"
               (colorPickerChange)="changeColor($event)"
               (colorPickerSelect)="selectColor($event)"
               (colorPickerCancel)="cancelColor()"
               [(colorPicker)]="pickedColor">
        <i class="flag-icon material-icons" [style.color]="pickedColor">flag_circle</i>
        <button *ngIf="showResetButton" matSuffix mat-icon-button type="button"
                aria-label="Reset"
                (click)="$event.stopPropagation();resetValueToDefault()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</mat-form-field>



